import React from 'react'
import DealingsNavigator from "../../components/DealingsNavigator";
import getObjectValue from "libs/getObjectValue";
import {FieldArray} from "formik";
import OrderObjectDividedList from "./OrderObjectDividedList";


function OrderObjectDivided(
    {
        id,
        formikProps,
        realizationType
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const curIndex = gVal("orderDealing", false, -1);

    const addPart = (arrayHelpers) => {
        const arr = gVal("divided", true, []);
        arrayHelpers.push({
            "dealingValue": null,
            "dealingValueCurrency": null,
            "purchaserNeedsDescription": null,
            "innovationProductNeed": null,
            "orderSubjectDescription": null,
            "mainCpv": null,
            "additionalCpv": null,
            "includesOptions": null,
            "includesOptionsInfo": null,
            "realizationPeriod": null,
            "realizationPeriodDateFrom": null,
            "realizationPeriodDateTo": null,
            "realizationPeriodAmount": null,
            "planRenewals": null,
            "planRenewalsInfo": null,
            "planOtherOrderForCurrentSupplier": null,
            "planOtherOrderForCurrentSupplierInfo": null
        });
        formikProps.setFieldValue(gId("dealingCount"), arr.length + 1);
    }

    const removePart = (arrayHelpers, index) => {
        const arr = gVal("divided", true, []);
        formikProps.setFieldValue(gId("dealingCount"), arr.length - 1)
        formikProps.setFieldValue("orderDealing", -1)
        arrayHelpers.remove(index);
    }

    return (<FieldArray
        name={gId("divided")}
        render={(arrayHelpers) => (<>
            <DealingsNavigator
                formikProps={formikProps}
                id="orderDealing"
                items={gVal("divided", true, [])}
                addPart={() => addPart(arrayHelpers)}
            />
            {curIndex > -1 &&
                <OrderObjectDividedList
                    formikProps={formikProps}
                    id={gId("divided." + curIndex)}
                    realizationType={realizationType}
                    index={curIndex}
                    removePart={(index) => removePart(arrayHelpers, index)}
                />
            }

        </>)}
    />)
}

OrderObjectDivided.propTypes = {};

export default OrderObjectDivided;
